import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { redefinirSenhaComToken } from '../../services/api';
import styles from './RedefinirSenha.module.css';

export default function RedefinirSenha() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [senhaNova, setSenhaNova] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [tipoMensagem, setTipoMensagem] = useState('');
  const [enviando, setEnviando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      setTipoMensagem('erro');
      setMensagem('Link invalido. Solicite uma nova recuperacao de senha.');
      return;
    }

    if (senhaNova !== confirmarSenha) {
      setTipoMensagem('erro');
      setMensagem('As senhas nao coincidem.');
      return;
    }

    if (senhaNova.length < 8) {
      setTipoMensagem('erro');
      setMensagem('A nova senha deve ter ao menos 8 caracteres.');
      return;
    }

    setEnviando(true);
    setMensagem('');
    setTipoMensagem('');

    try {
      await redefinirSenhaComToken(token, senhaNova);
      setTipoMensagem('sucesso');
      setMensagem('Senha redefinida com sucesso. Voce ja pode fazer login.');
      setSenhaNova('');
      setConfirmarSenha('');
      setTimeout(() => navigate('/cliente'), 2500);
    } catch (err) {
      setTipoMensagem('erro');
      setMensagem(err.message || 'Erro ao redefinir senha.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <>
      <Header />
      <main className={styles.container}>
        <section className={`${styles.card} ui-surface`}>
          <h1>Nova senha</h1>
          <p className={styles.subtitulo}>Defina uma nova senha para acessar sua conta.</p>

          {!token ? (
            <div className={styles.aviso}>
              <p>Link invalido ou incompleto.</p>
              <Link to="/cliente">Voltar para o login</Link>
            </div>
          ) : (
            <form className={styles.form} onSubmit={handleSubmit}>
              <label>Nova senha *</label>
              <input
                className="ui-input"
                type="password"
                value={senhaNova}
                onChange={(e) => setSenhaNova(e.target.value)}
                required
                minLength={8}
                autoComplete="new-password"
              />

              <label>Confirmar nova senha *</label>
              <input
                className="ui-input"
                type="password"
                value={confirmarSenha}
                onChange={(e) => setConfirmarSenha(e.target.value)}
                required
                minLength={8}
                autoComplete="new-password"
              />

              {mensagem && (
                <p className={tipoMensagem === 'sucesso' ? styles.sucesso : styles.erro}>
                  {mensagem}
                </p>
              )}

              <button className="ui-button-primary" type="submit" disabled={enviando}>
                {enviando ? 'Salvando...' : 'Redefinir senha'}
              </button>
            </form>
          )}

          <p className={styles.voltar}>
            <Link to="/cliente">Voltar para o login</Link>
          </p>
        </section>
      </main>
      <Footer />
    </>
  );
}
